import { render, staticRenderFns } from "./PopupCom.vue?vue&type=template&id=428020e8&scoped=true"
import script from "./PopupCom.vue?vue&type=script&lang=js"
export * from "./PopupCom.vue?vue&type=script&lang=js"
import style0 from "./PopupCom.vue?vue&type=style&index=0&id=428020e8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428020e8",
  null
  
)

export default component.exports